/**
 * `/lessons` — the lesson-package catalogue. Booking a lesson (`/lessons/book`)
 * is reached from the header's "Book a Lesson". A later slice wraps the panel
 * in the Lessons tabs; the page itself stays chrome only.
 */

import { LessonPageHeader, LessonsCatalogue } from './components';

export function LessonPackagesPage() {
  return (
    <div className="mx-auto max-w-7xl">
      <LessonPageHeader
        title="Choose your lesson package"
        subtitle="Find the right package based on your goals and lesson needs"
      />
      <LessonsCatalogue />
    </div>
  );
}
